// Hits templates
import post from './hits/post';
import page from './hits/page';
import studentStory from './hits/student-story';
import program from './hits/program';
import programPdp from './hits/program-pdp';
import studyAbroad from './hits/program-studyabroad';
import event from './hits/event';
export { default as stats } from './widgets/stats';

// Custom widgets
export { default as getPaginationTemplate } from './widgets/pagination';
export { default as getSearchBoxTemplate } from './widgets/search-box';
export { default as getRefinementTemplate } from './widgets/refinement';
export { default as getEmptyHitsTemplate } from './empty';

/**
 * Provide a template given hit type.
 *
 * @param string  overline attribute for overline
 * @param boolean simple   display simple tease?
 *
 * @returns function hit template
 */
export function getHitTemplate(overline, simple) {
  return hit => {
    const typeMapping = {
      post,
      page,
      program,
      ['student-story']: studentStory,
      ['pdp-program']: programPdp,
      ['studyabroad-program']: studyAbroad,
      event,
    };

    const templateFunction = typeMapping[hit.type] || typeMapping['page'];
    return templateFunction(hit, overline, simple);
  };
}
